import React from "react";
import { GatsbySeo } from "gatsby-plugin-next-seo";
import "../styles/turismoPage.css";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import CTAComponent from "../components/CTAComponent";
import ContactForm from "../components/ContactForm";

const turismo = () => {
  return (
    <>
      <GatsbySeo
        title="Turismo"
        description="todos los mejores servicios de turismo para que tengas tus mejores vacaciones"
        canonical="https://omega-agencia.netlify.app/turismo/"
        metaTags={[
          {
            property: "og:url",
            content: "https://omega-agencia.netlify.app/turismo/",
          },
          {
            property: "og:title",
            content: "Turismo | Omega Agencia de Viajes",
          },
        ]}
      />
      <section className="turismo-banner-align">
        <div className="turismo-title-align">
          <h1>Turismo 🏝</h1>
          <div className="turismo-btn-align">
            <Link className="turismo-btn" to="/destinos/">
              Viaja Ahora
            </Link>
          </div>
        </div>
        <div className="turismo-img-align">
          <StaticImage
            src="../images/turismo-banner.jpg"
            className="turismo-img-banner"
            alt="omega logo"
            quality={100}
            loading="lazy"
            placeholder="tracedSVG"
          />
        </div>
      </section>
      <article>
        <div className="turismo-desc-title">
          <h2>Turismo Omega</h2>
        </div>
        <div className="turismo-desc-align">
          <div className="turismo-desc">
            <p>
              Ofrecemos atractivas soluciones en viajes de negocios y placer.
              Haremos de su travesía una experiencia mágica y única. Contamos
              con el equipo de profesionales altamente capacitados y con amplia
              experiencia, dispuestos a brindarle la asesoría que usted merece a
              la hora de planificar su travesía, cualquiera que sea su destino,
              pues lo más importante es su comodidad y tranquilidad.
            </p>
          </div>
        </div>
        <div className="turismo-servicios-align">
          <div className="turismo-serv-img-align">
            <StaticImage
              src="../images/turismo-img.jpg"
              className="turismo-img-servicios"
              alt="omega logo"
              quality={100}
              loading="lazy"
              placeholder="tracedSVG"
            />
          </div>
          <div className="servicios-turismo-desc">
            <h3>Ofrecemos diversidad de servicios:</h3>
            <div className="servicios-list">
              <ul>
                <li>
                  Reservas en hoteles y paquetes turísticos nacionales e
                  internacionales.
                </li>
                <li>Alquiler de autos.</li>
                <li>Servicio de seguro de viajes.</li>
                <li>Traslados terrestres.</li>
                <li>
                  Cruceros, tours para quinceañeras, circuitos por Europa, venta
                  de tickets para trenes, excursiones, paquetes de ski, lunas de
                  miel, entre otros servicios.
                </li>
                <li>
                  Viajes estructurados adaptados especialmente a sus
                  requerimientos.
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="turismo-desc-align">
          <div className="turismo-desc">
            <p>
              En Agencia de Viajes Omega, establecemos negociaciones con
              nuestros aliados comerciales, a fin de ampliar nuestras opciones
              de servicios turísticos que nos permita contar con diversas
              alternativas y mejores beneficios para su comodidad.
            </p>
            <p>
              Cada año realizamos viajes de inspección para seleccionar los
              hoteles y proveedores que nos puedan garantizar la calidad de
              servicios e instalaciones para su tranquilidad y bienestar,
              siempre en la búsqueda de ofrecerle las mejores alternativas de
              servicios.
            </p>
            <p>
              En cumplimiento con las normativas de la Lopcymat, y la exigencia
              de divulgar y promocionar el turismo social, le brindamos nuestra
              asesoría en la selección de destinos turísticos y estructuración
              del paquete de viaje, atendiendo sus requerimientos, para que sea
              promocionado dentro del personal de su empresa.
            </p>
          </div>
        </div>
      </article>
      <CTAComponent />
      <ContactForm />
    </>
  );
};

export default turismo;
